<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="query.kind == 1">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/project/detail?id=${query.cid ? query.cid : query.pid}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>更新支付</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else-if="query.kind == 2">
        <el-breadcrumb-item>行政采购项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/admin/view?id=${query.cid ? query.cid : query.pid}&mType=2` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>更新支付</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else-if="query.kind == 3">
        <el-breadcrumb-item>行政采购项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/human' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/admin/view?id=${query.cid ? query.cid : query.pid}&mType=3` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>更新支付</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/pay' }">支付管理</el-breadcrumb-item>
        <el-breadcrumb-item>更新支付</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">供应商信息</h3>
      <ul>
        <li>
          <p>
            <label>供应商名称：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.vendor : ''
            }}</a>
          </p>
          <template v-if="tempPayList.vendorArr && tempPayList.vendorArr.type == 1">
            <p>
              <label>付款账户：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.payee_name : '' }}</a>
            </p>
          </template>
          <template v-else>
            <p>
              <label>付款账户：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.payee_name : '' }}</a>
            </p>
          </template>
          <p>
            <label>银行名称：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.payee_bank : '' }}</a>
          </p>
          <p>
            <label>银行账号：</label><a class="hoverlink" @click="clickCopy(tempPayList.vendorArr.payee_bank_account)">{{
              tempPayList.vendorArr ? tempPayList.vendorArr.payee_bank_account : '' }}</a>
          </p>
        </li>
        <li>
          <template v-if="tempPayList.vendorArr && tempPayList.vendorArr.type == 1">
            <p>
              <label>统一社会信用代码：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.company_id_card : '' }}</a>
            </p>
            <p>
              <label>公司注册地址：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.reg_address : '' }}</a>
            </p>
            <p>
              <label>公司电话：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.company_phone : '' }}</a>
            </p>
          </template>
          <template v-else>
            <p>
              <label>身份证号：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.id_card : ''
              }}</a>
            </p>
            <p>
              <label>住址：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.family_address :
                '' }}</a>
            </p>
            <p>
              <label>联系人电话：</label><a>{{ tempPayList.vendorArr ? tempPayList.vendorArr.phone : ''
              }}</a>
            </p>
          </template>
        </li>
      </ul>
    </div>

    <div class="base1">
      <h3 class="ntitle">项目信息</h3>
      <ul>
        <li>
          <p>
            <label>客户公司名称：</label><a>{{ projectArr.client_company }}</a>
          </p>
          <p>
            <label>项目名称：</label><a>{{ projectArr.contract_name }}</a>
          </p>
          <p>
            <label>服务类目：</label><a>{{ tempPayList.service_type_name }}</a>
          </p>
          <p>
            <label>供应商发票合计金额：</label><a>{{ tempPayList.vendorTotalInvoice }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>品牌：</label><a>{{ projectArr.brand }}</a>
          </p>
          <p>
            <label>子项目名称：</label><a>{{ tempSonList.contract_name }}</a>
          </p>
          <p>
            <label>服务说明：</label><a>{{ tempPayList.service_info }}</a>
          </p>
        </li>
      </ul>
    </div>

    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">更新支付</div>
        <el-form ref="form" :model="form" label-width="150px" label-position="left" class="ulform">
          <el-form-item label="选择支付计划：" prop="plan_id" v-if="query.kind == 1 || query.kind == 2 || query.kind == 3">
            <el-col :span="12">
              <el-select v-model="form.plan_id" placeholder="请选择" style="width:100%;" @change="planChange">
                <el-option :label="v.plan_name" :value="v.id" v-for="(v, i) in tempPayList.planList" :key="i"></el-option>
              </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="选择支付计划：" prop="plan_id" v-else>
            <el-col :span="12">
              {{ form.plan_name }}
            </el-col>
          </el-form-item>

          <el-form-item label="计划支付时间：" prop="hope_pay_time">
            <el-col :span="12">
              {{ form.hope_pay_time }}
            </el-col>
          </el-form-item>

          <template>
            <ul class="anlist">
              <li v-for="(item, index) in form.planDetailList" :key="index">
                <div class="abox">
                  <el-form-item label="计划支付金额：" prop="pay_amount">
                    <el-col :span="12">
                      {{ item.pay_amount }}
                    </el-col>
                  </el-form-item>

                  <el-form-item label="付款时间：" prop="pay_time">
                    <el-col :span="5">
                      <i class="ico-reddot" style="left: -160px;">*</i>
                      <el-date-picker v-model="item.pay_time" type="datetime" value-format="yyyy-MM-dd"
                        style="width: 100%;"
                        :disabled="((item.id && item.id != 0) || (item.pay_detail_id && item.pay_detail_id != 0)) && level != 1">
                      </el-date-picker>
                    </el-col>
                  </el-form-item>

                  <template>
                    <ul class="anlist">
                      <li v-for="(_it, _id) in item.atta_str" :key="_id">
                        <div class="abox">

                          <el-form-item :label='`付款凭证附件${index + 1}：`'>
                            <!-- 选择文件 -->
                            <el-col :span="3" v-if="(!_it.id && !_it.file_id) || level == 1">
                              <i class="ico-reddot" style="left: -160px;">*</i>
                              <el-upload class="upload-demo" :ref="`upFile${_id}`" action="#" :limit="1"
                                :show-file-list="false" :auto-upload="false"
                                accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="_it.flist"
                                :on-change="(arg) => uploadFile(arg, item.atta_str, `upFile${_id}`, _it, _id)">
                                <el-button size="small" style="width: 100%">选择文件</el-button>
                              </el-upload>
                            </el-col>
                            <!-- 文件预览及下载 -->
                            <template v-if="_it.origin_name">
                              <el-col :span="10">
                                <el-col :span="18">
                                  <div class="origin-name">{{
                                    _it.origin_name }}</div>
                                </el-col>
                                <el-col :span="4">
                                  <el-link type="primary" style="margin-right:5px" :href="_it.httpFile"
                                    target="_blank">查看</el-link>
                                </el-col>
                              </el-col>
                            </template>
                          </el-form-item>
                        </div>
                        <el-button class="bbtn" v-if="_id === 0" icon="el-icon-plus" @click="addImage(item.atta_str)"
                          circle></el-button>
                        <el-button class="bbtn" v-if="_id > 0 && ((!_it.id && !_it.file_id) || level == 1)" icon="el-icon-minus"
                          @click="removeImage(item.atta_str, _id)" circle></el-button>
                      </li>
                    </ul>
                  </template>
                </div>
              </li>
            </ul>
          </template>
        </el-form>

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>

      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { thousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'propay',
  data() {
    return {
      mType: '',
      level: '',
      tempPayList: [
        { vendorArr: { type: '', } }
      ],//临时支付数组
      tempSonList: [],//临时子数组
      billList: [],
      projectArr: {},
      sonList: [],
      form: {
        plan_id: '',
        hope_pay_time: '',
        planDetailList: [{
          pay_amount: '',
          pay_time: '',
          atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }],
        }],
      },
      p: 1,
      type: 0,
      rules: {

      },
      del_atta_list: [],
    }
  },
  created() {
    this.query = this.$route.query
    this.query.cid && this.getProjectDetail(this.query.cid)
    this.query.mType && (this.mType = this.query.mType)
  },
  mounted() {

  },
  watch: {
    ['tempPayList.vendorArr.payee_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.tempPayList.vendorArr.payee_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 2);
      api.uploadFile(formData)
        .then((res) => {
          fileList[index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][0].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addImage(arr) {
      console.log(arr);
      arr.push({ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] });
      this.$forceUpdate()
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
      this.$forceUpdate()
    },
    getProjectDetail(id) {
      this.checkUrlFn()
      api.getProjectDetail({ project_id: id }).then((res) => {
        this.billList = res.billList
        this.projectArr = res.itemArr
        this.sonList = res.sonList.filter(item => item.id)
        this.trackList = res.trackList
        for (let i = 0; i < this.sonList.length; i++) {
          let _son_pay = this.sonList[i].payList;
          this.sonList[i].payList = this.sonList[i].payList.map((item) => {
            return item.vendorTotalInvoice = thousands(item.vendorTotalInvoice)
          })
          for (let j = 0; j < _son_pay.length; j++) {
            const _son_pay_id = _son_pay[j].id;
            if (_son_pay_id == this.query.id) {
              this.tempPayList = _son_pay[j]//获取对应的payList
              this.tempSonList = this.sonList[i]
              if (this.query.planid) {//从列表页进入
                for (let k = 0; k < _son_pay[j].planList.length; k++) {
                  const ele = _son_pay[j].planList[k];
                  if (this.query.planid == ele.id) {
                    const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }];
                    const { plan_name, hope_pay_time, plan_amount, planDetailList } = ele
                    if (planDetailList.length != 0) {
                      planDetailList.map((item) => {
                        return item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str()
                      })
                    }
                    this.form = {
                      pay_id: this.query.id,
                      plan_id: this.query.planid ? this.query.planid : '',
                      plan_name: plan_name,
                      hope_pay_time: hope_pay_time,
                      planDetailList: planDetailList.length != 0 ? planDetailList : [{
                        pay_detail_id: 0,
                        pay_amount: plan_amount,
                        pay_time: '',
                        atta_str: atta_str(),
                      }],
                    }
                  }
                }
              }
              else {//从查看页进入
                this.tempPayList.planList = this.tempPayList.planList.map((item) => {//只取已审核订单
                  return item.pay_check_status == '3' ? item : ''
                }).filter((s) => { return s })
                // this.tempPayList.planList = this.tempPayList.planList.map((item) => {//只取已审核且未支付订单
                //   return item.pay_check_status == '3' && item.pay_status != '3' ? item : ''
                // }).filter((s) => { return s })
                const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
                this.form = {
                  pay_id: this.query.id,
                  hope_pay_time: '',
                  planDetailList: [{//防止空      
                    pay_amount: '',
                    pay_time: '',
                    atta_str: atta_str(),
                  }],
                }
              }
            }
          }
          this.$forceUpdate()
        }
        setTimeout(() => {
          //权限
          this.level = store.state.level
          this.realName = store.state.realName
          console.log(this.level);
        }, 200);        
      })
    },
    planChange() {
      let atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
      this.tempPayList.planList.forEach(item => {
        if (item.id == this.form.plan_id) {
          let { id, planDetailList, hope_pay_time, plan_amount } = item
          if (planDetailList.length != 0) {
            planDetailList.map((item) => {
              return item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str()
            })
          }
          this.form = {
            ...this.form,
            plan_id: id,
            hope_pay_time,
            planDetailList: planDetailList.length != 0 ? planDetailList : [{
              pay_detail_id: 0,
              pay_amount: plan_amount,
              pay_time: '',
              atta_str: atta_str(),
            }],
          }
          this.$forceUpdate()
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdatePay()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdatePay() {
      if (this.form.planDetailList[0].pay_time == '0000-00-00' || !this.form.planDetailList[0].pay_time) {
        this.$message.error('请选择支付时间')
        return false
      }
      if (this.form.planDetailList[0].atta_str[0].origin_name == '') {
        this.$message.error('请上传附件')
        return false
      }
      // 替换掉id为receive_id
      const $planDetailList = this.form.planDetailList.map((item) => {
        delete item.pay_plan_id
        delete item.create_time
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['pay_detail_id'] = item[key] || 0
            console.log(item['pay_detail_id']);
            delete item[key]
          }
        })
        // 替换掉id为file_id
        item.atta_str = item.atta_str.map((it) => {
          delete it.flist
          delete it.httpFile
          Object.keys(it).forEach(_key => {
            if (_key == 'id') {
              it['file_id'] = it[_key] || 0
              delete it[_key]
            }
          })
          return it
        })
        delete item.file_id
        return item
      })
      this.form.planDetailList = $planDetailList
      this.form.pay_status = '3'
      this.$fly
        .post('apiProject_updatePayPlan.html', {
          ...this.form,
          detail_str: JSON.stringify(this.form.planDetailList),
          atta_del: this.del_atta_list.toString(),
          mType: this.mType,
        })
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg.replace(/\s*/g, ""))
        e.preventDefault() // 阻止默认行为
      }
      const once = {
        once: true
      }
      document.addEventListener('copy', save, once) // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy') // 执行copy方法
      this.$message({ message: '复制成功', type: 'success' })
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: var(--text-1); /* 0819修改 */;
      background: var(--bg-soft); /* 0819修改 */
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }


        }
      }
    }
  }
}
</style>